import Image from 'next/image'
import { Fragment } from 'react'

/**
 * To render the basic Rating component
 * rootClassName - class name of the root element
 * rating - rating of the stars
 * starClassName - class name of the rating element
 * ratingType - Type of the rating whether Star | Advisor
 */
export default function Rating(props) {
	/**
	 * Render method called here
	 * rootClassName - class name of the root element
	 * rating - rating of the stars
	 * starClassName - class name of the rating element
	 * ratingType - Type of the rating whether Star | Advisor
	 * ratingValue - Value of the rating
	 * ratingValueClassName -  Class name of the rating value
	 * advisorSource - image source of the advisor
	 * isInside - whether rating element render inside the p or no
	 * insideClassName - class name of insider element
	 * beforeElement - element to render before the rating
	 * insideFirstElement - render the first element in inside the p
	 */
	const {
		rootClassName,
		starClassName,
		rating,
		tripAdvisorReviewCount,
		insideClassName,
		insideFirstElement,
		ratingType,
		ratingValueClassName,
		ratingValue,
		isInside,
		children,
		advisorSource,
		agodaSource,
		beforeElement,
		halfStarClassName,
		defaultClassName,
		maximumRating,
		enableFullRating,
		alternateHotelRating,
	} = props
	const renderRatings = (rating, className) => {
		const roundRating = isNaN(parseFloat(rating)) ? 0 : Math.ceil(rating)
		return Array(roundRating)
			.fill(0)
			.map((rate, index) => {
				if (roundRating === index + 1 && roundRating !== parseFloat(rating))
					return <i key={rate + index} className={halfStarClassName} />
				return <i key={rate + index} className={className} />
			})
	}

	const renderEmptyRating = rating => {
		if (rating >= maximumRating || rating < 0) return null
		return Array(rating)
			.fill(0)
			.map((rate, index) => {
				return <i key={rate + index} className={defaultClassName} />
			})
	}

	const renderInsideElement =
		ratingType === 'STAR' || ratingType === 'ADVISOR' ? (
			<Fragment>
				{insideFirstElement}
				{rootClassName ? (
					<span className={rootClassName}>
						{renderRatings(rating, starClassName)}
						{enableFullRating
							? renderEmptyRating(maximumRating - Math.ceil(rating))
							: null}
					</span>
				) : null}
				{ratingValue ? (
					<span className={ratingValueClassName}>{ratingValue}</span>
				) : null}
				{children}
			</Fragment>
		) : alternateHotelRating ? (
			<span>
				{rating} ({tripAdvisorReviewCount}{' '}
				{tripAdvisorReviewCount > 1 ? 'reviews' : 'review'})
			</span>
		) : (
			<span>
				Rated <b> {rating} </b>
				<br /> {tripAdvisorReviewCount}{' '}
				{tripAdvisorReviewCount > 1 ? 'reviews' : 'review'}
			</span>
		)

	return (
		<Fragment>
			{ratingType === 'ADVISOR' && rating ? (
				<Image src={advisorSource} alt={'Tripadvisor Rating'} />
			) : ratingType === 'AGODA' && rating ? (
				<Image src={agodaSource} alt={'Agoda Rating'} />
			) : null}{' '}
			{beforeElement}
			{isInside ? (
				<p className={insideClassName}>{renderInsideElement}</p>
			) : (
				renderInsideElement
			)}
		</Fragment>
	)
}

/**
 * Default value of the popular has been assigned
 */
Rating.defaultProps = {
	rootClassName: 'star-rating',
	defaultClassName: 'pyt-star-outline-16',
	maximumRating: 5,
	enableFullRating: true,
	starClassName: 'pyt-star-16',
	halfStarClassName: 'pyt-half-star-16',
	ratingType: 'STAR',
	ratingValue: 0,
	ratingValueClassName: 'ta-txt',
	isInside: false,
	insideFirstElement: null,
	beforeElement: null,
	insideClassName: 'meta-text',
	advisorSource:
		'https://pyt-images.imgix.net/images/icons/tripadvisor-owl.png',
	enableLazyLoad: true,
	alternateHotelRating: false,
	agodaSource: 'https://pyt-images.imgix.net/images/icons/agoda-icon.png',
}
